// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"251":"6a43a6c542269318b500","348":"194f9abbe4344f38c4b6","885":"319cc425e62e183322d7"}[chunkId] + ".js";
};